const zh_CN = {
    //Common
    "SCREEN_BEAM":"ScreenBeam",
    "FIRST_NAME": "First Name",
    "LAST_NAME": "Last Name",
    "EMAIL": "Email",
    "PHONE":"Phone",
    "PASSWORD":"密码",
    "CONFIRM_PASSWORD":"Confirm password",
    "ROLES": "Roles",
    "ROLE": "Role",
    "DELETE": "Delete",
    "RECEIVERS": "Receivers",
    "ID":"ID",
    "CMS": "CMS",
    "BORN_ON_DATE": "Born On Date",
    "EXPIRATION": "Expiration",
    "COMPANY": "Company",
    "COMPANY_NAME": "Company Name",
    "COMPANY_PHONE":"Company Phone",
    "COMPANY_ADDRESS":"Company Address",
    "FEATURES": "Features",
    "SHOW_HIDE_COLUMNS":"Show/Hide Columns",
    "ERROR":"ERROR: ",
    "SEARCH":"搜索...",
    "CURRENTLY_VIEWING":"当前正在查看: {dataCount}",
    "TOTAL_COUNT":"总数: {totalDataCount}",
    "SELECTED":"选中数: {selectedDataCount}",
    "SYMBOL_COLON":":",
    "WARNING": "WARNING",
    "SAVE": "Save",
    "BACK": "Back",
    "SUBMIT": "Submit",
    "ACCEPT":"Accept",
    "SAVE_CHANGES":"Save Changes",
    "EMPTY_FIELD_ERROR":"Please enter a ",
    "INVALID_EMAIL":"Please enter the correct email address",
    "BLOCK_EMAIL_DOMAIN":"This email's domain is blocked. Please enter another email address.",
    "INVALID_PHONE":"Please provide a valid phone number",
    "LIMIT_LENGTH_32":"Must be 1 - 32 characters",
    "LIMIT_LENGTH_64":"Must be 1 - 64 characters",
    "LIMIT_LENGTH_256":"Must be 1 - 256 characters",
    "LIMIT_LENGTH_9_64":"Must be 9 - 64 characters",
    "LIMIT_LENGTH_0_32":"Description character length cannot exceed 32",
    "EMAIL_LIMIT_LENGTH":"Email address length cannot exceed 255",
    "DESCRIPTION_LIMIT_LENGTH":"Description character length cannot exceed 256",
    "PASSWORD_NOT_MATCH":"Password do not match",
    "SELECT_PERMISSION_ERROR":"Select at least one Permissions",
    "SIGN_UP_ERROR":"An error occurred during signup.",
    "TENANT_REGISTERED_SUCCESS":"Email has been sent to user to complete account activation!",
    "UNKNOWN_ERROR":"An unknown error occurred. Please try again later.",
    "INVALID_PASSWORD":"Password must be least one upper case English letter [A-Z], least one lower case English letter [a-z], at least one digit [0-9]. At least one special character.",
    "403_FORBIDDEN":"403: Forbidden {newline}You do not have the required permissions to access this route",
    "PASSCODE_EXPIRED_OR_INVALID": "Passcode is expired or invalid",
    "ACTIVE": "Active",
    "NOT_ACTIVATED": "Not Activated",
    
    //Roles: the display name of PermissionIds
    "255cffa0-ab88-4168-880e-6d60df62e4b3":"AlertPlus App Teacher View",
    "12e1f72c-420e-4298-b441-3859ce4fb65b":"Edit AlertPlus",
    "c3344f95-06ee-46f9-ac42-28a658cd6a4d":"Edit Orchestrate Server",
    "a1826c14-18bb-4f2f-bdec-2c9bac8ff7a3":"Edit CMS",
    "e5501406-af8c-4ccb-91e3-fc37b206b1be":"Edit User",
    "756801b1-e505-49a0-8eb8-88a66a13bd89":"Edit Licenses",
    "f420ec4c-0ebc-4ad9-8e89-77075bbae9d2":"Edit HW Warranty",
    "dcc0473d-e1cb-4ed7-88a3-9eaa83a68621":"View HW Warranty",
    "b78572a0-d7b5-4b1c-bb38-44c0b1310ef4":"Support",

    //Confirm Modal
    "CANCEL": "Cancel",
    "CONFIRM_BTN":"Confirm",
    "CONFIRMATION":"Confirmation",
    "CONFIRM_MESSAGE":"Are you sure you want to permanently delete {counts} {dataType}?",
    "CONFIRM_ACCOUNT_DELETE":"WARNING: Deleting the {dataType} is permanent, and all associated data will be deleted. Proceed?",

    //PageType, title
    "Users": "Users",
    "Account Management": "Account Management",
    "Alert Plus": "Alerts Plus",
    "CMS Management": "CMS Management",
    "Companies": "Companies",
    "Licenses": "Licenses",
    "Roles":"Roles",
    "Hardware Warranty": "Hardware Warranty",

    //Login page
    "SCREENBEAM_CLOUD":"ScreenBeam Cloud",
    "EMAIL_ADDRESS":"Email address",
    "FORGOT_PASSWORD":"Forgot password?",
    "LOG_IN":"Log In",
    "INVALID_PARAMETERS":"Invalid parameters.",
    "INCORRECT_USERNAME_PASSWORD_ROLES":"Incorrect username or password or no roles assigned or email has not been verified.",
    "SERVER_ERROR":"Server error.",

    //Forgot Password Page
    "FORGOT_PASSWORD_TITLE":"Forgot password?",
    "FORGOT_PASSWORD_DESCRIPTION":"Please contact your ScreenBeam Service Portal Account Owner to reset your password. If you are the Account Owner please contact ScreenBeam Support.",  
    "FORGOT_PASSWORD_EMAIL_SENT": "If {email} is registered with Screenbeam Cloud an email has been sent. Follow the instructions in the email to reset your password.",

    //Reset Password Page
    "RESET_PASSWORD": "Reset password",
    "RESET_PASSWORD_SUCCESS": "Successfully changed password.",

    //Activate User Page
    "ACTIVATE_USER_SUCCESS": "Successfully changed password and activated user.",

    //Resend Verification Email page
    "RESEND_VERIFICATION_EMAIL":"Resend Verification Email",
    "RESEND_VERIFICATION_EMAIL_SENT":"Check your email for a verification link.",
    "VERIFICATION_EMAIL_LINK_EXPIRED":"Verification link has expired, click the button below to resend a verification link to {email}",
    "RESEND":"Resend",
    "VERIFY_USER":"Verify User",

    //SSO Signin
    "PERMISSIONERROR":"You do not have permission to register CMSE to your ScreenBeam Cloud tenant",
    "INCORRECTCREDENTIALS":"Incorrect email or password",
    "INVALIDCMSID":"Please obtain the correct CMS ID",

    //Navbar
    "EDIT_ACCOUNT_INFO": "Edit account info",
    "ENTER_PHONE_NUMBER":"Enter phone number",
    "LOG_OUT":"Log Out",
    "ENGLISH":"English",
    "CHINESE":"中文",

    //Sidebar
    "DASHBOARD": "仪表板",
    "USER_MANAGEMENT": "用户管理",
    "ACCOUNT_MANAGEMENT":"客户管理",
    "LICENSE_MANAGEMENT": "许可证管理",
    "CMS_MANAGEMENT": "CMS管理",
    "ALERTS_PLUS": "Alerts Plus",
    "ORCHESTRATE": "Orchestrate",
    "HARDWARE_WARRANTY": "硬件保修",
    "SETTINGS": "设置",
    "SUPPORT":"支持",
    "APPLICATION_LIBRARY":"Applications Library",

    //User Management
    "ADD_USER": "Add User",
    "IMPORT_USERS": "Import Users",
    "SET_ROLES": "Set Roles",
    "ADD_USER_SUCCESS":"Successfully added user(s)!",
    "ADD_USER_FAILED":"Failed to add user: {errorMsg}",
    "EDIT_USER_SUCCESS":"Successfully edited user!",
    "EDIT_USER_FAILED":"Failed to edit user: {errorMsg}",
    "DELETE_USER_SUCCESS":"User deleted successfully!",
    "DELETE_USER_FAILED":"Failed to delete user: {errorMsg}",
    "DELETE_USERS_FAILED":"Failed to delete users: {errorMsg}",
    "DELETE_OWNER_ERROR":"Cannot delete account owner",
    "DELETE_USER_NO_ELIGIBLE_USERS":"No eligible users to delete.",
    "COUNT_USERS_DELETED_SUCCESS":"{userCounts} users deleted successfully!",
    "COUNT_USERS_EDITED_SUCCESS":"{userCounts} users edited successfully!",
    "SUBMIT_ERROR":"Please fill out all fields",
    "PASSWORDS_NOT_MATCH":"Passwords did not match",
    "NO_USERS_SELECTED":"No users selected",
    "NO_ROLES_SELECTED":"No roles selected",
    "NO_USERS_TO_DELETE":"No users to delete.",
    "EDIT_USER_ROLES_FAILED":"Failed to edit user-roles: {errorMsg}",
    "RESENT_TO_EMAIL":"Successfully resent verification link to {email}",
    "RESENT_TO_EMAIL_FAIL":"Failed to resend verification link to {email}",
    //User Modal
    "EDIT_USER":"Edit User",
    //Role Modal
    "NAME":"Name",
    "ASSIGN_ROLES":"Assign Roles",
    //Import Modal
    "IMPORT_USERS_EXAMPLE":"Import a set of users via CSV {newline}Phone must be in E.164 format {newline}Example:",
    "IMPORT_USERS_SUCCESS": "Successfully imported users. Successful: {successfulCount}, Failing: {failingCount}, Duplicates: {duplicateCount}.",
    "IMPORT_USERS_PARTIAL_SUCCESS":"Some rows failed to import",
    "IMPORT_USERS_FAILED":"Failed to import users",
    "IMPORT_USERS_SUCCESSFUL_ROWS":"Successful Rows:",
    "IMPORT_USERS_FAILED_ROWS":"Failing Rows:",
    "IMPORT_USERS_DUPLICATE_ROWS":"Duplicate Users:",

    //Account Management
    "ADD_ACCOUNT": "Add Account",
    "EDIT_ACCOUNT":"Edit account",
    "DELETE_ACCOUNT": "Delete Account",
    "DELETE_ACCOUNT_WARNING": "Deleting the account is permanent and all associated data will be deleted. Proceed?",
    "ACCOUNT_OWNER":"Account Owner",
    "CREATE_AN_ACCOUNT":"Create an account",
    "EDIT_ACCOUNT_FAILED":"Failed to edit account. Please try again later.",
    "EDIT_ACCOUNT_SUCCESS":"Successfully edited account!",
    "DELETE_ACCOUNT_SUCCESS":"Successfully deleted accounts",
    "ADDED_ACCOUNT_SUCCESS":"Successfully added account",
    
    //License Management
    "ACTIVATE": "Activate",
    "DEACTIVATE": "Deactivate",
    "REFRESH": "Refresh",
    "REFRESH_LICENSES_SUCCESS":"Successfully refreshed licenses!",
    "REFRESH_LICENSES_FAILED":"Failed to refresh licenses",
    "LICENSE": "License",
    "ACTIVATION_KEY": "Activation Key",
    "ACTIVATE_LICENSE":"Activate License",
    "LICENSE_KEY":"License key",
    "REMAINING": "Remaining",
    "SEATS": "Seats",
    "SEATS_USED":"Seats Used",
    "LICENSE_EULA_MODAL_TITLE":"Please review the Terms of Service carefully and click Accept to continue.",
    "LICENSE_READ_AND_AGREE":"I have read and agree to the Terms of Use and End-User License Agreement.",
    "LICENSE_ALREADY_ACTIVATED":"A license for this feature has already been activated. Unable to activate new license. Please contact support for more details at support@screenbeam.com",
    "ACTIVATION_KEY_INVALID":"Activation key invalid",
    "DEACTIVATE_LICENSE_KEY_SUCCESS":"Successfully deactivated license(s)!",
    "DEACTIVATE_LICENSE_KEY_FAILED":"Failed to deactivate license(s): {info}",
    "LICENSE_ACTIVATED_SUCCESS":"Successfully activated license!",
    "LICENSE_ACTIVATED_INFO":"Activation in progress, please wait...",

    //Cms Management
    "STATUS": "Status",
    "LAST_SEEN": "Last Seen",
    "SITES": "Sites",
    "VERSION": "Version",
    "LOGS": "Logs",
    "DELETE_CMSES_SUCCESS":"Successfully deleted CMSes!",
    "DELETE_CMSES_FAILED":"Failed to delete CMSes",

    //Alerts Plus
    "SITE": "Site",
    "ALERTS_LOG":"Alerts Log",
    "ADD_ALERTS_PLUS_USER":"Add Alerts Plus User",
    "EDIT_ALERTS_PLUS_USER":"Edit Alerts Plus User",
    "RESEND_VERIFICATION":"Resend Verification",
    "ADDED_USER_SUCCESS":"Successfully added user!", 
    "CHANGED_SUCCESS":"Successfully changed!",
    "SUCCESS_RESENT_VERIFICATION_TO":"Successfully resent verification to: {email}",
    "SELECT_CMS":"Select CMS",
    "NO_CMSE_AVAILABLE":"No CMSes available",
    "SELECT_SITES":"Select Sites",
    "NO_SITES_AVAILABLE":"No sites available",  
    //Alerts Plus Template
    "ALERT_PLUS_TEMPLATE_MAKER":"Screenbeam Alert Plus Template Maker", 
    "ALERT_NAME":"Alert Name",
    "SET_SITE": "Set Site",
    "UPLOAD_AN_ICON":"Upload an icon(.png, .jpg)...",
    "ALERT_PLUS_SET_ICONS_WARNING":"Ensure that icons can be clearly seen in both light and dark backgrounds",
    "ALERT_PLUS_IMAGE_WARNING":"Image aspect ratio will be maintained",
    "ICON":"Icon",
    "IMAGE":"Image",
    "DURATION":"Duration",
    "ALERT_PLUS_MAKE_PRESET":"Make Preset?",
    "DURATION_INDEFINITE":"Indefinite",
    "DURATION_1_MINUTE":"1 minute",
    "DURATION_MINUTES":"{number} minutes",
    "DURATION_1_HOUR":"1 hour",
    "DURATION_HOURS":"{number} hours",
    "NO":"No",
    "ALERT_SOUND":"Alert Sound",
    "CREATE_ALERT":"Create Alert",
    "UPDATE_ALERT":"Update Alert",
    "ALERT_PLUS_CLOSE_WINDOW_BTN":"Close Window",
    "ALERT_PLUS_CREATE_EDIT_SUCCESS":"Successfully {methodText} template. ",
    "AUTO_CLOSE_WINDOW":"This window will automatically close.",

    //Orchestrate
    "GO_TO_ORCHESTRATE": "Go to Orchestrate",

    //Hardware Warranty
    "MODEL_NAME": "Model Name",
    "MAC": "MAC",
    "MACs": "MACs",
    "SERIAL_NUMBER": "Serial Number",
    "ACCOUNT_EMAIL":"Account Email",
    "OWNER_EMAIL":"Owner Email",
    "EDIT_EXPIRATION":"Edit Expiration",
    "DELETE_RECEIVER":"Delete Receiver",
    "IMPORT_RECEIVERS":"Import Receivers",
    "SHOW_RECEIVERS":"Show Receivers",
    "NO_DATA_FOUND":"No data found",
    "EDIT_RX_EXPIRATION_SUCCESS":"Successfully edited receiver expiration",
    "DELETED_RECEIVERS_SUCCESS":"Successfully deleted receivers",
    "IMPORT_RECEIVERS_SUCCESS":"Successfully imported receivers",
    "SELECT_A_COMPANY":"Select a Company...",
    "SELECT_FILE":"Select File",
    "FEEDBACK_LOOKS_GOOD":"Looks good!",
    "IMPORT":"Import",
    "EDIT_RECEIVERS":"Edit Receivers",
    "RECEIVER_EXPIRATION":"Receiver Expiration",
    //Import Receivers
    "IMPORT_RECEIVERS_ERROR":"Something went wrong with the import. Please try again.",
    "SELECTE_COMPANY_FOR_IMPORT_RECEIVERS":"Both company and a file must be selected for the import.",

    //Roles
    "ADD_ROLES": "Add Roles",
    "PERMISSIONS": "Permissions",
    "#_USERS": "# Users",
    "DESCRIPTION": "Description",
    "EDIT_ROLE":"Edit Role",
    "ADD_ROLE":"Add Role",
    "ROLE_NAME":"Role Name",
    "DELETE_ROLES_ERROR":"No roles selected for deletion or cannot delete the Account Owner role",
    "DELETE_ROLES_FAILED_INFO":"Failed to delete roles: {info}",
    "COUNT_ROLES_DELETE_SUCCESS":"{count} Roles deleted successfully!",
    "ROLE_ADDED_SUCCESS":"Role added successfully",
    "ROLE_UPDATED_SUCCESS":"Role updated successfully",

    //Settings
    "SETTINGS_TITLE": "Settings",
    "GLOBAL_POLICIES": "Global Policies",
    "PASSWORD_LENGTH": "Password Length",
    "MINIMUM_LENGTH": "Minimum Length",
    "REQ_PASSWORD_CHANGE": "Require password change on first login",
    "TWO_FA": "Two-factor authentication",
    "PREFERENCES": "Preferences",
    "DARK_MODE": "Dark Mode",
    "MISSING_PASSWORD_MINI_LENGTH":"Missing password minimum length.",
    "PASSWORD_NOT_MEET_MINI_LENGTH":"Password does not meet minimum length.",
    "SUCCESS":"Success!",
    "CURRENT_PASSWORD_INCORRECT":"Current password is incorrect",
    //Change Password Modal
    "CHANGE_PASSWORD":"Change Password",
    "CURRENT_PASSWORD":"Current Password",
    "NEW_PASSWORD":"New Password",
    "FIELD_CANNOT_EMPTY":"Field cannot be empty",
    "LOGGED_OUT_SUCCESS":"You will be logged out on success",
    "DONE_BTN":"Done",
    //Check Email Modal
    "CHECK_EMAIL_FOR_RESET_PASSWORD":"Please check your email for the link to reset your password.",
    "SEND_EMAIL_FAILED":"Failed to send email.",
    "SEND_EMAIL_SUCCESS":"Email successfully sent!",

    //Support
    "ACCOUNT_ID":"Account ID",
    "CMSES":"CMSes",
    "COMPANY_ID":"Company ID",
    "WITH_ROLES":"With roles",
    "WITH_BASE_PERMISSIONS":"With base permissions",
    "RECEIVERS_PER_PRODUCT":"Receivers per Product",
    "TOTAL_RECEIVERS":"Total receivers",
    "CUSTOMERS_REGISTERED_RXS":"Customers who have registered receivers",

    //CMSE CONNECT TO CLOUD
    "CMSE_CONNECT_SUCCESS":"ScreenBeam Cloud Connection Successful",
    "RETURN_TO_CMSE_DASHBOARD":"Return to CMS Dashboard",
    "CONNECT_TO_CLOUD_BTN_DESCRIPTION":"Connect to ScreenBeam Cloud to access premium features and to manage licenses",
    "CONNECT_TO_CLOUD_BTN_LABEL":"Connect Now",
    "BACK_BTN":"Back",
    "CMSE_LOGIN_TITLE":"Log in to ScreenBeam Cloud",
    "CMSE_LOGIN_SUB_TITLE":"Sign-in to connect your cloud to CMS",
    "FORGOT_LOGIN_PASSWORD":"Forgot login/password",
    "DONT_ACCOUNT":"Don't have an account?",
    "SIGN_UP":"Sign Up",
    "CONNECT_BTN":"Connect",
    "TERMS_AND_CONDITIONS":"Terms and Conditions",
    "AGREE_TERMS_AND_CONDITIONS":"I agree to these terms and conditions",
    "CONTINUE_BTN":"Continue",
    "CMSE_SIGN_UP_TITLE":"Sign Up for ScreenBeam Cloud",
    "CMSE_SIGN_UP_SUB_TITLE":"Create your account to unlock the full potential of your devices",
    "CREATE_ACCOUNT_BTN":"Create Account",
    "VERIFY_ACCOUNT_TITLE":"Verify your account",
    "VERIFY_ACCOUNT_SUB_TITLE":"Please enter the code that was sent to your email: {email}",
    "ENTER_CODE":"Enter Code",
    "DIDNT_RECV_CODE":"Didn't receive the code?",
    "RESEND_CODE":"Resend Code",
    "ASSIGN_NAME_FOR_CMSE":"Assign a friendly name for your CMS",
    "ACCOUNT_CREATED_SUCCESS":"Account created successfully",
    "CONNECTIONG_TO_CLOUD":"Connecting to Cloud...",

    //MESSENGER STATUS
    "MESSENGER_pending": "Pending",
    "MESSENGER_inqueue": "In Queue",
    "MESSENGER_inprocess": "In Process",
    "MESSENGER_stopbyuser": "Stopped By User",
    "MESSENGER_half-complete": "Half-Complete",
    "MESSENGER_complete": "Complete",
    "MESSENGER_failed": "Failed",
    "MESSENGER_unknown": "Unknown",
    
    // User Management
    "USER_HAS_DIFFERENT_SITES_PER_FEATURE": "This user has different sites assigned to different features. Saving will update all selected features with the same sites.",
  }

  export default zh_CN;